import { useSelector } from "react-redux";

import KeyPointsPage from "./keypoints/KeyPointsPage";
import ReadingPage from "./reading/ReadingPage";
import FlowPage from "./flow/FlowPage";
import SentenceTestPage from "./sentence_test/SentenceTestPage";
import VocabularyPage from "./vocabulary/VocabularyPage";
import SyntaxAnalysisPage from "./syntax_analysis/SyntaxAnalysisPage";

const AnalysisPage = ({ setCurrentStep, isPreview, isReview }) => {
  const { section } = useSelector((state) => state.assignment);

  if (section.type === "keypoints") {
    return (
      <KeyPointsPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (section.type === "reading") {
    return (
      <ReadingPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (section.type === "flow") {
    return (
      <FlowPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (section.type === "sentence_test") {
    return (
      <SentenceTestPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (section.type === "words") {
    return (
      <VocabularyPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (section.type === "syntax_analysis") {
    return (
      <SyntaxAnalysisPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  }

  return (
    <div>
      <h1>Section Page</h1>
    </div>
  );
};

export default AnalysisPage;
